import { useGetApiProjectsByProjectIdAnalysisSpecsQuery } from '@/model/analysisSpec/api.generated';
import { useGetApiProjectsByProjectIdEtlSourcesQuery } from '@/model/etlSource/api.generated';
import { useGetApiProjectsByProjectIdEtlTaskChainsQuery } from '@/model/etlTasks/api.generated';
import { useLiveUpdatesEnabled } from '@/viewmodel/features/etlSource';
import { useChainRunNotifications } from '@/viewmodel/features/observability/hooks/useChainRunNotifications';
import { useGoldChainUserRefresh } from '@/viewmodel/features/observability/hooks/useGoldChainUserRefresh';
import { useSpecRunNotifications } from '@/viewmodel/features/observability/hooks/useSpecRunNotifications';
import { useSourceStatesViewModel } from '@/viewmodel/features/sourceState';

const POLL_INTERVAL_MS = 15_000;

export function useGlobalRunNotifications(
  projectId: string | undefined,
  workspaceId?: string,
): void {
  const liveUpdates = useLiveUpdatesEnabled();

  const { data: specs } = useGetApiProjectsByProjectIdAnalysisSpecsQuery(
    { projectId: projectId ?? '', limit: 100 },
    { skip: !projectId, pollingInterval: POLL_INTERVAL_MS, skipPollingIfUnfocused: true },
  );

  const { data: chains } = useGetApiProjectsByProjectIdEtlTaskChainsQuery(
    { projectId: projectId ?? '', limit: 50 },
    { skip: !projectId, pollingInterval: POLL_INTERVAL_MS, skipPollingIfUnfocused: true },
  );

  const { data: sources } = useGetApiProjectsByProjectIdEtlSourcesQuery(
    { projectId: projectId ?? '' },
    {
      skip: !projectId,
      pollingInterval: liveUpdates ? 0 : POLL_INTERVAL_MS,
      skipPollingIfUnfocused: true,
    },
  );

  const { statusById } = useSourceStatesViewModel(projectId, liveUpdates);

  useSpecRunNotifications(specs?.data?.items);
  useChainRunNotifications(chains?.data?.items, sources?.data?.items, statusById, workspaceId);
  useGoldChainUserRefresh(chains?.data?.items);
}
